export default function optionScopeMessage(
  unsupported: Array<string>,
  label: (column: string) => string,
): string | undefined {
  if (!unsupported.length) {
    return undefined;
  }
  const reasons: Array<string> = [];
  if (unsupported.includes('embedded_sql_parameters')) {
    reasons.push('This report uses a separate choice list, which may include values outside your current filters.');
  }
  if (unsupported.includes('linked_options_budget')) {
    reasons.push('The narrowed choice list could not be loaded, so broader choices are shown.');
  }
  if (unsupported.includes('unlinked_options_unavailable')) {
    reasons.push('The broader choice list could not be loaded.');
  }
  const fields = unsupported.filter(
    (entry) => !['embedded_sql_parameters', 'linked_options_budget', 'unlinked_options_unavailable'].includes(entry),
  );
  if (fields.length) {
    reasons.push(`Choices are not narrowed by: ${fields.map(label).join(', ')}.`);
  }
  return reasons.join(' ');
}
